import { useParams } from 'react-router-dom';
import { useJobGet } from '../hooks/use-job.hook';
import { memo } from 'react';
import JobDetailsComponent from '../components/job-details.component';
import HeaderRow from '../../../../common/HeaderRow';
import { useTranslation } from 'react-i18next';
import ErrorFallback from '../../../../common/ErrorFallback';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const JobDetailsContainer = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading, error } = useJobGet(id || '');

  if (!id) {
    return (
      <ErrorFallback
        details={t('common.errorLoadingData')}
        icon={<ExclamationCircleOutlined />}
        error={new Error(t('common.invalidIdProvided'))}
        resetErrorBoundary={() => {}}
      />
    );
  }

  if (error) {
    return (
      <>
        <PageTitle title={t('crud.details.title', { entity: t('jobs.title') })} />
        <HeaderRow
          title={t('crud.details.title', { entity: t('jobs.title') })}
          showBackButton={true}
        />
        <ErrorFallback
          details={t('common.errorLoadingData')}
          icon={<ExclamationCircleOutlined />}
          error={error}
          resetErrorBoundary={() => {}}
        />
      </>
    );
  }

  return (
    <>
      <PageTitle title={t('crud.details.title', { entity: t('jobs.title') })} />
      <HeaderRow
        title={t('crud.details.title', { entity: t('jobs.title') })}
        showBackButton={true}
      />
      <div className="row mt-3">
        <JobDetailsComponent
          data={data?.data}
          success={data?.success ?? false}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(memo(JobDetailsContainer), 'job.view');
